import { useEffect, useState } from 'react'
import fallbackImage from '../../../assets/images/image_not_available.jpg'
import loadingImage from '../../../assets/images/loading-gif.webp'
import axios from '../../../axios'
import { getDB } from 'repositories/indexdb/db'

export const useDownloadPicture = (container, filename) => {
  const [imageUrl, setImageUrl] = useState(loadingImage)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!filename || filename.trim() === '' || filename.trim() === '-') {
      setImageUrl(fallbackImage)
      setLoading(false)
      return
    }

    let isMounted = true

    const cacheKey = `image-cache:${container}:${filename}`
    const loadImage = async () => {
      setLoading(true)
      setError(false)

      try {
        const db = await getDB()
        const cached = await db.get('files', cacheKey)

        if (cached) {
          const blob = new Blob([cached.blob], { type: 'image/*' })
          const objectUrl = URL.createObjectURL(blob)
          if (isMounted) {
            setImageUrl(objectUrl)
            setLoading(false)
            setError(false)
          }
          return
        }
        const response = await axios.get(
          `Storages/${container}/download/${filename}`,
          { responseType: 'blob' }
        )
        const blob = response.data

        await db.put(
          'files',
          { key: cacheKey, blob, created: Date.now() },
          cacheKey
        )
        const objectUrl = URL.createObjectURL(blob)
        if (isMounted) {
          setImageUrl(objectUrl)
          setLoading(false)
          setError(false)
        }
      } catch (e) {
        console.error('Image fetch error:', e)
        if (isMounted) {
          setImageUrl(fallbackImage)
          setError(true)
          setLoading(false)
        }
      }
    }
    loadImage()

    return () => {
      isMounted = false
    }
  }, [filename, container])

  return [{ imageUrl, loading, error }]
}
